<template>
  <v-container fluid>
    <div class="text-center">
      <v-container fluid>
        <v-card
          max-width="900"
          class="mx-auto mb-8"
          elevation="5"
          v-for="existingPlan in ExistingLessonPlans"
          :key="existingPlan.id"
        >
          <v-card-text class="mt-5">
            <v-row>
              <v-container fluid>
                <v-card outlined>
                  <v-toolbar dark dense>Lesson Plan Header</v-toolbar>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" md="12" lg="12" class="text-h5 pa-0">
                        Title: {{ existingPlan.title }}
                      </v-col>
                      <v-col cols="12" md="12" lg="12" class="py-0">
                        Unit:
                        {{
                          existingPlan.unit ? existingPlan.unit.objective : ""
                        }}
                      </v-col>

                      <v-col cols="12" md="12" lg="12" class="py-0">
                        Learning Objective/Essential Question:
                        {{ existingPlan.essential_question }}
                      </v-col>

                      <v-col cols="12" md="12" lg="12" class="py-0">
                        Learning Standards:
                        <v-list dense>
                          <v-list-item
                            dense
                            v-for="standard in existingPlan.standards"
                            :key="standard.phaseRank"
                          >
                            {{ standard.objective }}
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-container>
            </v-row>
            <v-row>
              <v-container fluid>
                <v-card outlined>
                  <v-toolbar dark dense>Lesson Plan Content</v-toolbar>
                  <v-col
                    v-for="(content, id) in existingPlan.contents"
                    :key="id"
                    cols="12"
                    md="12"
                    lg="12"
                  >
                    <v-card outlined v-if="content.visible">
                      <v-toolbar color="grey lighten-2" dense>
                        <v-toolbar-title>
                          {{ content.type ? content.type : "Untitled" }}
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-card-text v-html="content.content"></v-card-text>
                    </v-card>
                  </v-col>
                </v-card>
              </v-container>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </div>
    <div class="text-center">
      <v-snackbar v-model="snackbar" :multi-line="true">
        {{ snackbarMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    ExistingLessonPlans: [],
    snackbar: false,
    snackbarMessage: "",
  }),
  computed: {},
  methods: {
    getExistingLessonPlans() {
      this.$sisApi("get", "my-schedule/content", {
        course_id: this.$store.state.course.course_id,
        section: this.$store.state.course.section,
        date: this.$store.state.course.start.substr(0, 10),
        period: this.$store.state.course.period,
      })
        .then((response) => {
          this.ExistingLessonPlans = response.data;
        })
        .catch((error) => {
          this.snackbar = true;
          this.snackbarMessage = error.response.data.message;
          console.log(error);
        });
    },
  },
  mounted() {
    this.getExistingLessonPlans();
  },
};
</script>
